const c = {
  name: "Hospitality",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30,35V11c0-6.1-4.9-11-11-11h-6C6.9,0,2,4.9,2,11v24H0v2h3.1c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3h10.3
			c0.4,1.7,2,3,3.9,3c1.9,0,3.4-1.3,3.9-3H32v-2H30z M4.1,10C4.6,5.5,8.4,2,13,2h6c4.6,0,8.4,3.5,8.9,8H4.1z M4,12h24v21.4
			c-0.5-0.6-1.2-1-2-1.2V24c0-1.7-1.3-3-3-3h-3v-4h-8v4H9c-1.7,0-3,1.3-3,3v8.1c-0.8,0.2-1.5,0.6-2,1.2V12z M18,21h-4v-2h4V21z
			 M9,23h14c0.5,0,1,0.5,1,1v8.1c-1.4,0.4-2.5,1.5-2.9,2.9H10.9c-0.4-1.4-1.5-2.5-2.9-2.9V24C8,23.5,8.5,23,9,23z M7,34
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C5,34.9,5.9,34,7,34z M23,36c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2
			C23.9,38,23,37.1,23,36z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hospitality
};
